import type { FileCodeTagProps } from "./types";

export const FileCodeTag = ({ fileCode }: FileCodeTagProps) => (
  <span className="flex-shrink-0 whitespace-nowrap font-normal normal-case tracking-normal text-gray-500">
    ({fileCode})
  </span>
);
